const TOGGLE_PREFERENCES_MODAL = 'TOGGLE_PREFERENCES_MODAL';
const TOGGLE_PROFILE_OPTIONS_MODAL = 'TOGGLE_PROFILE_OPTIONS_MODAL';
const GET_AVAILABLE_LANGUAGES = 'GET_AVAILABLE_LANGUAGES';
const SET_AVAILABLE_LANGUAGES = 'SET_AVAILABLE_LANGUAGES';
const SET_SELECTED_LANGUAGE = 'SET_SELECTED_LANGUAGE';
export {
  TOGGLE_PREFERENCES_MODAL,
  TOGGLE_PROFILE_OPTIONS_MODAL,
  GET_AVAILABLE_LANGUAGES,
  SET_AVAILABLE_LANGUAGES,
  SET_SELECTED_LANGUAGE,
};
